var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.83052C5 6.21422 5.49962 5.7146 6.11592 5.7146H8.34777C8.96408 5.7146 9.4637 6.21422 9.4637 6.83052V9.06237C9.4637 9.67868 8.96408 10.1783 8.34777 10.1783H6.11592C5.49962 10.1783 5 9.67868 5 9.06237V6.83052Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7656 6.83052C13.7656 6.21422 14.2652 5.7146 14.8815 5.7146H17.1134C17.7297 5.7146 18.2293 6.21422 18.2293 6.83052V9.06237C18.2293 9.67868 17.7297 10.1783 17.1134 10.1783H14.8815C14.2652 10.1783 13.7656 9.67868 13.7656 9.06237V6.83052Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5352 6.83052C22.5352 6.21422 23.0348 5.7146 23.6511 5.7146H25.8829C26.4992 5.7146 26.9989 6.21422 26.9989 6.83052V9.06237C26.9989 9.67868 26.4992 10.1783 25.8829 10.1783H23.6511C23.0348 10.1783 22.5352 9.67868 22.5352 9.06237V6.83052Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15.5996C5 14.9833 5.49962 14.4836 6.11592 14.4836H8.34777C8.96408 14.4836 9.4637 14.9833 9.4637 15.5996V17.8314C9.4637 18.4477 8.96408 18.9473 8.34777 18.9473H6.11592C5.49962 18.9473 5 18.4477 5 17.8314V15.5996Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 24.3669C5 23.7506 5.49962 23.251 6.11592 23.251H8.34777C8.96408 23.251 9.4637 23.7506 9.4637 24.3669V26.5987C9.4637 27.2151 8.96408 27.7147 8.34777 27.7147H6.11592C5.49962 27.7147 5 27.2151 5 26.5987V24.3669Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7656 15.5996C13.7656 14.9833 14.2652 14.4836 14.8815 14.4836H17.1134C17.7297 14.4836 18.2293 14.9833 18.2293 15.5996V17.8314C18.2293 18.4477 17.7297 18.9473 17.1134 18.9473H14.8815C14.2652 18.9473 13.7656 18.4477 13.7656 17.8314V15.5996Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7656 24.3669C13.7656 23.7506 14.2652 23.251 14.8815 23.251H17.1134C17.7297 23.251 18.2293 23.7506 18.2293 24.3669V26.5987C18.2293 27.2151 17.7297 27.7147 17.1134 27.7147H14.8815C14.2652 27.7147 13.7656 27.2151 13.7656 26.5987V24.3669Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5352 15.5996C22.5352 14.9833 23.0348 14.4836 23.6511 14.4836H25.8829C26.4992 14.4836 26.9989 14.9833 26.9989 15.5996V17.8314C26.9989 18.4477 26.4992 18.9473 25.8829 18.9473H23.6511C23.0348 18.9473 22.5352 18.4477 22.5352 17.8314V15.5996Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5352 24.3669C22.5352 23.7506 23.0348 23.251 23.6511 23.251H25.8829C26.4992 23.251 26.9989 23.7506 26.9989 24.3669V26.5987C26.9989 27.2151 26.4992 27.7147 25.8829 27.7147H23.6511C23.0348 27.7147 22.5352 27.2151 22.5352 26.5987V24.3669Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationsIcon);
export default __webpack_public_path__ + "static/media/applications_icon.a7e4f87f190a6ae2b1d888df401f5833.svg";
export { ForwardRef as ReactComponent };